<template>
  <div class="home"
       style="background-color: #fff;"
       v-loading="loading">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class=" currency_box">
      <div style="margin:30px 0;align-items: flex-start;"
           class="flexStart">
        <el-image width="450px"
                  height="250px"
                  style="width:450px;height:250px;"
                  :src="activityData.iconUrl"></el-image>
        <div style="flex:1;margin-left: 20px;">
          <div class="font24"
               style="color:#333333;margin-bottom: 20px;">{{activityData.outerName}}</div>
          <div> <span class="flexStart"> <i class="el-icon-phone-outline"
                 style="margin-right:3px"></i> {{activityData.hotLine}}</span>
            <div style="margin:26px 0;"> <i class="el-icon-location-outline"
                 style="margin-right:3px"></i> {{activityData.courseClassify == '1'?activityData.areaStr:''}}</div>
            <div v-if="activityData.startTimeShort"><i class="el-icon-time"
                 style="margin-right:3px"></i>{{activityData.startTimeShort+'至'+activityData.endTimeShort}}</div>
          </div>
          <div class="flexStart"
               style="margin-top: 20px;">
            <div v-if="activityData.activityState!=3">
              <el-button type="danger"
                         @click="toForm(1)">会员免学费</el-button>
            </div>

            <div style="margin:0 10px 0 20px"
                 v-if="activityData.activityState!=3">
              <el-button type="danger"
                         @click="toForm(2)">立即报名</el-button>
            </div>

            <div style="margin:20px 20px 0 0"
                 v-if="activityData.activityState==3">
              <el-button type="danger"
                         disabled>活动已过期</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <!-- <div class="totalList">
        <div class="total_box currency_box">

          <div style="flex:1">
            <div class="font18"
                 style="color:#333333;margin-bottom: 20px;">{{activityData.outerName}}</div>
            <div class="flexStart"> <span style=""
                    class="flexStart"> <i class="el-icon-phone-outline"
                   style="margin-right:3px"></i> {{activityData.hotLine}}</span>
              <span style="margin-left: 20px;"
                    class="flexStart"> <i class="el-icon-time"
                   style="margin-right:3px"></i> {{activityData.courseClassify == '1'?activityData.areaStr + ' | ':''}}</span>
              <span style="margin-left:10px"
                    v-if="activityData.startTimeShort">{{activityData.startTimeShort+'至'+activityData.endTimeShort}}</span>
            </div>
          </div>


          <div v-if="activityData.activityState!=3">
            <el-button type="danger"
                       @click="toForm(1)">会员免学费</el-button>
          </div>

          <div style="margin:0 10px 0 20px"
               v-if="activityData.activityState!=3">
            <el-button type="danger"
                       @click="toForm(2)">立即报名</el-button>
          </div>
        </div>
      </div> -->
      <div class="currency_boxs"
           style="min-width: 1200px;">
        <div style="margin-bottom: 10px;"
             class="font20">活动详情</div>
        <div v-html="activityData.description"></div>
      </div>
      <!-- <div class="currency_box">
        <el-image :src="url"></el-image>
      </div>
      <div class="currency_box">
        <el-image :src="url"></el-image>
      </div> -->
    </div>
  </div>
</template>

<script>
import { activityInfo, selectMyEnterprise } from '@/api/api.js'
export default {
  components: {},
  data () {
    return {
      loading: false,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      activityData: {}
    }
  },
  created () {
    this.init()
  },
  filters: {

  },
  methods: {
    toForm (type) {
      if (type == 1) {
        // this.$router.push('/Card?type=cur')
        this.$router.push('/Form?type=17')
      } else {
        this.getselectMyEnterprise()
      }
    },
    async getselectMyEnterprise () {
      if (!localStorage.getItem('accessToken')) {
        this.$refs.topNav.login()
        return
      }
      const res = await selectMyEnterprise()
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      if (res.data && res.data.length != 0) {
        this.$router.push('/Confirm?type=order&id=' + this.$route.query.id)
      } else {
        this.$router.push('/Form?type=17')
      }
    },
    init () {
      this.loading = true;
      if (this.$route.query.id) {
        this.getactivityInfo(this.$route.query.id)
      }
    },
    async getactivityInfo (id) {
      const res = await activityInfo(id)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      const regex = new RegExp('<img', 'gi');
      res.data.description = res.data.description.replace(regex, `<img style="width: 100%;"`);
      this.activityData = res.data;
      this.loading = false;
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
  .swpier {
    width: 100%;
    height: 392px;
    background-color: #fff;
  }
  .box {
    min-width: 1200px;
    // height: 850px;
    // font-size: 0;
    // background-image: url('http://wechatapppro-1252524126.file.myqcloud.com/crm/image/jpeg/l8e8s93q05cz.jpg');
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    position: relative;
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom: 20px;
    // opacity: 0.8;
    .totalList {
      position: absolute;
      z-index: 12;
      top: -55px;
      left: 0;
      height: 110px;
      // background-color: #fff;
      width: 100%;
      .total_box {
        background-color: #fff;
        height: 100%;
        border-radius: 6px;
        padding: 24px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
